module.exports = __webpack_public_path__ + "img/wujinmu1.06b7e51c.jpg";